import React from 'react';
import { SecondaryButton } from 'jl-ui-kit/elements/button/Button';

import styles from './feedback-item.scss';

const FEEDBACK_LINK =
  'https://edigitalsurvey.com/survey/enter/s/ESV-136225211/data2/mobile/collection_url/';

function FeedbackItem() {
  return (
    <div className={styles.feedback} data-testid="feedback-item">
      <h3 className={styles.title}>Feedback</h3>
      <p>Your comments help us improve our website</p>
      <SecondaryButton
        tag="a"
        href={FEEDBACK_LINK}
        {...{ target: '_blank', rel: 'noopener' }}
      >
        Leave Feedback
      </SecondaryButton>
    </div>
  );
}

export default FeedbackItem;
